import {
  TableContainer,
  Table,
  Paper,
  Box,
  CircularProgress,
} from "@mui/material";
import clsx from "clsx";
import { useEffect, useRef } from "react";
import { Text } from "$components";
import { useStyles } from "../DataTable.styles";
import { Thead } from "./Thead";
import { TBody } from "./TBody";
import { TFooter } from "./TFooter";

import { DataTableProps } from "../DataTable.type";
import { useDataDispatch, useDataPagination } from "../DataTableContext";

export const DataTable = ({
  queryFunctionName,
  queryFunction,
  CollapsedChildren,
  rowsPerPage = 50,
  thead,
  className = "",
  withThead = true,
  usePaper = true,
}: DataTableProps) => {
  const classes = useStyles();
  const refContainer = useRef<HTMLDivElement>(null);

  const { data, initialQuery, isLoading } = useDataPagination();

  const dispatch = useDataDispatch();

  useEffect(() => {
    if (!initialQuery) {
      dispatch({
        type: "initialize",
        payload: { queryFunction, queryFunctionName, rowsPerPage, thead },
      }); // TODO move this in action file
    }
  }, [
    queryFunction,
    queryFunctionName,
    rowsPerPage,
    dispatch,
    initialQuery,
    thead,
  ]);

  useEffect(() => {
    dispatch({
      type: "updateHeader",
      payload: { thead },
    }); // TODO move this in action file
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thead]);

  return (
    <>
      <TableContainer
        className={clsx(classes.tableContainer, className)}
        component={usePaper ? Paper : undefined}
        ref={refContainer}
      >
        <Table className={classes.table} aria-label="custom pagination table">
          {withThead && <Thead thead={thead} />}
          {!isLoading && data?.length === 0 && (
            <tbody>
              <tr>
                <td colSpan={1000} style={{ paddingTop: 65 }}>
                  <Box className={classes.jLoadingTable}>
                    <Text type="h3">
                      Aucun résultat ne correspond à votre recherche
                    </Text>
                  </Box>
                </td>
              </tr>
            </tbody>
          )}
          {!isLoading && (
            <TBody
              thead={thead}
              data={data}
              isRowRelative={false}
              noPointer={false}
              noHover={false}
              CollapsedChildren={CollapsedChildren}
              queryFunctionName={queryFunctionName}
            />
          )}
          <TFooter />
        </Table>
      </TableContainer>
      {isLoading && (
        <Box className={classes.jNoResultPlaceHolder}>
          <Box className={classes.jLoadingTable}>
            <Text type="h3">Chargement en cours...</Text>
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      )}
    </>
  );
};
